import React, { useEffect, useMemo, useState } from 'react'
import { JOINT_HOMUNCULUS_DATA } from 'src/consumer/constants'

export const PrescriptionDataContext = React.createContext()

export default function PrescriptionDataProvider({ children }) {
  const [prescriptionData, setPrescriptionData] = useState(null)

  const [printType, setPrintType] = useState()

  const [selectedComplaints, setSelectedComplaints] = useState()
  const [selectedDiagnosis, setSelectedDiagnosis] = useState()
  const [selectedInvestigations, setSelectedInvestigations] = useState()
  const [selectedObservations, setSelectedObservations] = useState()
  const [selectedAdvice, setSelectedAdvice] = useState()
  const [selectedInstructions, setSelectedInstructions] = useState()
  const [jointHomunculusData, setJointHomunculusData] = useState(JOINT_HOMUNCULUS_DATA)
  const [nextVisitInputValue, setNextVisitInputValue] = useState()
  const [nextVisitInputType, setNextVisitInputType] = useState('days')
  const [selectedTherapies, setSelectedTherapies] = useState()
  const [selectedTherapist, setSelectedTherapist] = useState()
  const [discountedPriceOfSession, setDiscountedPriceOfSession] = useState()
  const [priceUpdateLoading, setPriceUpdateLoading] = useState(false)
  const [choseToGiveDiscount, setChoseToGiveDiscount] = useState(false)
  const [suggestedBookingTherapy, setSuggestedBookingTherapy] = useState(false)
  const [selectedAssessments, setSelectedAssessments] = useState()
  const [referredToDoctorName, setReferredToDoctorName] = useState()

  const [allVitalsOfThisPatient, setAllVitalsOfThisPatient] = useState()

  const [drugsAdvice, setDrugsAdvice] = useState()
  const [finalRequestedTestsBy, setFinalRequestedTestsBy] = useState()

  const [notesToTherapist, setNotesToTherapist] = useState()
  const [notesForAssessments, setNotesForAssessments] = useState()
  const [attachPrescriptionForTherapy, setAttachPrescriptionForTherapy] = useState()
  const [attachPrescriptionForAssessments, setAttachPrescriptionForAssessments] = useState()

  const [patientHistoryNotes, setPatientHistoryNotes] = useState()

  useEffect(() => {}, [])

  const contextValue = useMemo(() => {
    const newVal = {
    prescriptionData,
    setPrescriptionData,

    printType,
    setPrintType,

    drugsAdvice,
    setDrugsAdvice,
    selectedComplaints,
    setSelectedComplaints,
    selectedDiagnosis,
    setSelectedDiagnosis,
    selectedInvestigations,
    setSelectedInvestigations,
    selectedObservations,
    setSelectedObservations,
    selectedAdvice,
    setSelectedAdvice,
    selectedInstructions,
    setSelectedInstructions,
    jointHomunculusData,
    setJointHomunculusData,
    nextVisitInputValue,
    setNextVisitInputValue,

    nextVisitInputType,
    setNextVisitInputType,
    selectedTherapies,
    setSelectedTherapies,
    selectedTherapist,
    setSelectedTherapist,
    discountedPriceOfSession,
    setDiscountedPriceOfSession,
    priceUpdateLoading,
    setPriceUpdateLoading,
    choseToGiveDiscount,
    setChoseToGiveDiscount,
    suggestedBookingTherapy,
    setSuggestedBookingTherapy,
    allVitalsOfThisPatient,
    setAllVitalsOfThisPatient,
    selectedAssessments,
    setSelectedAssessments,
    finalRequestedTestsBy,
    setFinalRequestedTestsBy,

    referredToDoctorName,
    setReferredToDoctorName,
    notesToTherapist,
    setNotesToTherapist,
    attachPrescriptionForTherapy,
    setAttachPrescriptionForTherapy,

    notesForAssessments,
    setNotesForAssessments,
    attachPrescriptionForAssessments,
    setAttachPrescriptionForAssessments,

    patientHistoryNotes,
    setPatientHistoryNotes,
  }
  return newVal
  }, [
    prescriptionData, printType, drugsAdvice, selectedComplaints, selectedDiagnosis,
    selectedInvestigations, selectedObservations, selectedAdvice, selectedInstructions,
    jointHomunculusData, nextVisitInputValue, nextVisitInputType, selectedTherapies,
    selectedTherapist, discountedPriceOfSession, priceUpdateLoading, choseToGiveDiscount,
    suggestedBookingTherapy, allVitalsOfThisPatient, selectedAssessments, finalRequestedTestsBy,
    referredToDoctorName, notesToTherapist, attachPrescriptionForTherapy, notesForAssessments,
    attachPrescriptionForAssessments, patientHistoryNotes,
  ])

  return (
    <PrescriptionDataContext.Provider value={contextValue}>
      {children}
    </PrescriptionDataContext.Provider>
  )
}
